import { createApp } from 'vue';
import PageUpdateNotification from './PageUpdateNotification.vue';
import '../../../../css/components/page-update-notification-widget.less';
export function initPageUpdateNotificationWidget() {
    const el = document.getElementById('page-update-notification-widget');

    if (!el) return;

    const options = JSON.parse(el.dataset.options);

    createApp(PageUpdateNotification, options).mount(el);
}